
import { RouteNames } from '@/router/types';
import FormStore from '@/store/formStore';
import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

@Component
export default class AppFormOwnerCheck extends Vue {
  // VUEX MODULES
  formStore: FormStore | null = null;

  // HOOKS
  async created() {
    this.formStore = getModule(FormStore);
  }

  // METHODS
  resetForm() {
    this.formStore.resetForm();
    this.$router.push({ name: RouteNames.Crossroad });
  }
}
